import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHeader from '@/components/feature/PageHeader';
import GuidesSection from '@/pages/home/components/GuidesSection';

export default function Guides() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <PageHeader
          titleKey="page.guides.title"
          subtitleKey="page.guides.subtitle"
          breadcrumbKey="nav.guides"
        />
        <GuidesSection />
      </main>
      <Footer />
    </div>
  );
}